import { observer } from 'mobx-react-lite'
import { EmptyState } from 'shared/ui'
import surveysPreviewImg from 'shared/assets/images/surveys/surveys_preview.png'
import { getCDNAssetURL } from 'shared/lib'
import { NewSurveyButton, GuideButton } from 'pages/surveys/ui/SurveysActions/SurveysActions'

export const SurveysPageEmpty = observer(() => (
  <EmptyState
    variant={'preview'}
    previewImg={<img alt='Surveys preview' src={getCDNAssetURL(surveysPreviewImg)} />}
    title={'Create your first survey'}
    subtitle={'Gather customer feedback and measure satisfaction with ease'}
    actions={
      <>
        <NewSurveyButton />
        <GuideButton />
      </>
    }
  />
))
